import { imageDataToBase64 } from '@/common/images';
import { Camera } from '@/components/camera/component';
import { MobileContainer } from '@/components/workflow/mobile-container';
import { MobileHeader } from '@/components/workflow/mobile-header';
import { useBaleInboundContext } from '../hook';

export const InboundDocketPhotoPage = () => {
	const { setPage, workflowType, handleManualCreateInput } = useBaleInboundContext();

	const handlePhotoAccepted = async (imageData: ImageData) => {
		try {
			// Convert image data to base64 with high quality JPEG compression
			const photoDataUrl = `data:image/jpeg;base64,${imageDataToBase64(imageData, 'jpeg', 0.99)}`;

			// Save the photo to form data

			handleManualCreateInput('docketPhoto', photoDataUrl);

			// Navigate back to the root page
			setPage(workflowType === 'MANUAL' ? 'MANUAL_CREATE:ROOT' : 'EVALUATION');
		} catch (error) {
			console.error('Error processing docket photo:', error);
		}
	};

	return (
		<MobileContainer
			header={
				<MobileHeader
					title="Add Docket Photo"
					onBack={() => setPage(workflowType === 'MANUAL' ? 'MANUAL_CREATE:ROOT' : 'EVALUATION')}
				/>
			}
		>
			<Camera onTakePhoto={handlePhotoAccepted} />
		</MobileContainer>
	);
};
